import React, { useState, useEffect } from 'react'
import "./CustomDatatableRole.css";
import { useNavigate } from 'react-router-dom';
import { BiEdit } from "react-icons/bi"
import Pagination from '../Pagination/Pagination';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { MdDeleteForever } from "react-icons/md";
import DeleteConfirmation from '../DeleteConfirmation/DeleteConfirmation';
import { deleteRole, getRoles } from '../../services/http';
import { toast } from 'react-toastify';
import { FaRegEye } from "react-icons/fa";



const CustomDatatableRole = (props) => {
    const { columns, data, handleShowDeleteModal, handleCloseDeleteModal } = props;
    const dispatch = useDispatch();

    const [processOngoing, setProcessOngoing] = useState(false)

    const [pageNumber, setPageNumber] = useState(0);
    const itemsPerPage = 5;
    const pagesVisited = pageNumber * itemsPerPage;

    const navigate = useNavigate();

    const changePage = ({ selected }) => {
        setPageNumber(selected)
    }

    const pageCount = Math.ceil(data?.length / itemsPerPage);
    const states = useSelector((state) => state, shallowEqual);


    const handleYesClicked = async (role) => {
        setProcessOngoing(true)
        const reqdata = await deleteRole(role, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status !== 404 && reqdata.response.status !== 500) {
                let errorMsg = reqdata.response?.data.error;
                console.log(reqdata.response.data.error)
                let response = await getRoles(states.userToken.access_token);

                let response_copy = response.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))

                dispatch({
                    type: "SET",
                    key: "roleList",
                    payload: response_copy,
                });

                toast.error(errorMsg, {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'rotateY animated'
                });

            } else {
                let response = await getRoles(states.userToken.access_token);

                let response_copy = response.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))

                dispatch({
                    type: "SET",
                    key: "roleList",
                    payload: response_copy,
                });
                //    Should redirect to an Error Page
                console.log(reqdata.response?.data.message)
                toast.error(reqdata.response?.data.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'rotateY animated'
                });
            }
        } else {
            let response = await getRoles(states.userToken.access_token);

            let response_copy = response.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))

            dispatch({
                type: "SET",
                key: "roleList",
                payload: response_copy,
            });
            setProcessOngoing(false)
            toast.success("Role supprimé avec succès !", {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });
        }

    }


    return (
        <>
            <div className="table-responsive ">
                <table className="table table-striped dataTable w-100">
                    <thead className="">
                        <tr role={"row"}>
                            {columns && columns.map((item, index) =>
                                <th className="text-left pl-5" >
                                    {item.label}</th>
                            )}
                            <th className="text-center w-30">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length != 0 ? data.slice(pagesVisited, pagesVisited + 5).map((item, index) =>
                            <tr key={index+"wcdrd"}>

                                <td className="text-left pl-5">{index + 1}</td>
                                <td className="text-left pl-5">
                                    {item.name}
                                </td>

                                <td className="text-left">
                                    {Object.keys(item.permissions).length > 2 ?
                                        <ul>

                                            <li>
                                                {item.permissions[0].description}
                                            </li>
                                            <li>
                                                {item.permissions[1].description}
                                            </li>
                                            <li>
                                                ...
                                            </li>
                                        </ul> :
                                        <ul>
                                            {Object.keys(item.permissions).length !== 0 ? item.permissions.map((permission, index) =>
                                                <li key={index+"wcdrp"}>
                                                    {permission.description}
                                                </li>) : <div>
                                                Aucune Permission
                                            </div>}


                                        </ul>
                                    }

                                </td>

                                <td className="">
                                    {item.isDefault !== 1 && <BiEdit onClick={() => navigate(`/role/${item.id}`)} title="Modifier" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />}
                                    {item.isDefault !== 0 && <FaRegEye onClick={() => navigate(`/role/${item.id}/view`)} title="Visualiser" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />}
                                    {item.isDefault !== 1 && <MdDeleteForever onClick={() => handleShowDeleteModal(item.id)} title="Supprimer" style={{ fill: "red", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-delete-button ml-1" />}
                                </td>
                                <DeleteConfirmation processOngoing={processOngoing} handleYesClicked={handleYesClicked} title={` le role ${item.name} ?`} id={item.id} show={item.showDelete} handleNoClicked={handleCloseDeleteModal} />
                                {/* <DeleteConfirmationInstitutionCategory onExit={onExit} title={"Etes-vous sûr de vouloir supprimer la catégorie " + `${item.libelle}` + " ?"} idCategory={item.id} show={item.showDelete} handleNoClicked={handleCloseDeleteModal} /> */}
                            </tr>
                        ) : <h1 className="ok"></h1>}
                    </tbody>
                </table>
                <Pagination pageCount={pageCount} changePage={changePage} />
            </div>
        </>
    )
}

export default CustomDatatableRole